import { type ComponentProps, forwardRef } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

export const CustomPhoneInput = forwardRef<
  HTMLInputElement,
  ComponentProps<"input">
>((props, ref) => (
  <input
    {...props}
    ref={ref}
    className={cn(props.className, "border-0 font-medium focus:ring-0")}
  />
));
